export default {
    computed: {
        watchlists () {
            switch (this.type) {
                case 'course':
                    return this.$store.getters['Watchlists/getCourseSectionForWatchlists']
                case 'collection':
                    return this.$store.getters['Watchlists/getCollectionSectionForWatchlists']
                case 'learningPath':
                    return this.$store.getters['Watchlists/getLearningPathSectionForWatchlists']
                }
            return this.$store.getters['Watchlists/getCourseSectionForWatchlists']
        }
    },
    methods: {
        async showNewWatchlistModal () {
            switch (this.type) {
                case 'course':
                    await this.$store.dispatch('Watchlists/assignNewWatchlistCourse', this.elementId)
                    break
                case 'collection':
                    await this.$store.dispatch('Watchlists/assignNewWatchlistCollection', this.elementId)
                    break
                case 'learningPath':
                    await this.$store.dispatch('Watchlists/assignNewWatchlistLearningPath', this.elementId)
                    break
            }
            this.$modal.hide('add-to-watchlist-modal')
            this.$modal.show('add-to-new-watchlist')
        },
        async removeFromWatchlist (watchListId) {
            switch (this.type) {
                case 'course':
                    await this.$store.dispatch('Watchlists/removeCourseFromWatchlist', {
                        watchListId,
                        courseId: this.elementId
                    })
                    break
                case 'collection':
                    await this.$store.dispatch('Watchlists/removeCollectionFromWatchlist', {
                        watchListId,
                        collectionId: this.elementId
                    })
                    break
                case 'learningPath':
                    await this.$store.dispatch('Watchlists/removeLearningPathFromWatchlist', {
                        watchListId,
                        learningPathId: this.elementId
                    })
                    break
            }
        },
        async addToWatchlist (watchListId) {
            switch (this.type) {
                case 'course':
                    await this.$store.dispatch('Watchlists/addCourseToWatchlist', {
                        watchListId,
                        courseId: this.elementId
                    })
                    break
                case 'collection':
                    await this.$store.dispatch('Watchlists/addCollectionToWatchlist', {
                        watchListId,
                        collectionId: this.elementId
                    })
                    break
                case 'learningPath':
                    await this.$store.dispatch('Watchlists/addLearningPathToWatchlist', {
                        watchListId,
                        learningPathId: this.elementId
                    })
                    break
            }
        }
    }
}
